import type { PermissionKey } from "@/constants/permissions"
import useUser from "@/hooks/useUser"
import { ReactNode } from "react"

interface PermissionGateProps {
  /** Catalog permission key, e.g. PERMISSIONS.KB_UPLOAD. Admins always pass. */
  permission: PermissionKey
  children: ReactNode
  /** Rendered when the user lacks the permission (default: nothing). */
  fallback?: ReactNode
}

/**
 * Show children only if the current user has the given permission. Admins are a
 * wildcard (always allowed). Use to hide feature actions a member wasn't granted.
 */
export function PermissionGate({
  permission,
  children,
  fallback = null,
}: PermissionGateProps) {
  const { hasPermission } = useUser()
  return <>{hasPermission(permission) ? children : fallback}</>
}
